const styles = () => ({
    marginTop: {
        marginTop: '12px',
    },
    circularProgress: {
        position: 'absolute',
        top: '35px',
        right: '20px',
    },
    radioGroup: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        '& legend': {
            width: '100%',
            color: 'rgba(0, 0, 0, 0.54)',
            marginBottom: '12px',
            fontSize: '1rem',
        },
    },
});

export default styles;
